import React from 'react';
import { IncidentManagementScreen } from '../../screens/program-manager/incident-management-v2/IncidentManagementScreen';
import MiniRoute from '../common/MiniRoute';
import { useRoutesMap } from '../common/useRoutesMaps';
import { useIsPageHidden } from '../../global/auth/use-hidden-pages/use-hidden-pages';
import { VolunteersScreen } from '../../screens/program-manager/volunteers/VolunteersScreen';
import { ReportManagementScreen as ReportManagementScreenV2 } from '../../screens/program-manager/report-management-v2/ReportManagementScreen';
import { BulletinManagementScreen } from '../../screens/program-manager/bulletin-management/BulletinManagementScreen';
import { ManagementDashboardScreen } from '../../screens/program-manager/management-dashboard/ManagementDashboardScreen';
import { ProgramManagementScreen } from '../../screens/admin/program-management/ProgramManagementScreen';

export const getProgramManagerSubContentBlock = () => {
  const {
    management: { route, isAuthorized },
  } = useRoutesMap();
  const isPageHidden = useIsPageHidden();

  return [
    !isPageHidden('management.volunteers') && (
      <MiniRoute
        //
        key='volunteers'
        path={`/${route}/volunteers`}
        component={VolunteersScreen}
        isAuthorized={isAuthorized}
      />
    ),
    !isPageHidden('management.program-management') && (
      <MiniRoute
        //
        key='program-management'
        path={`/${route}/program-management`}
        component={ProgramManagementScreen}
        isAuthorized={isAuthorized}
      />
    ),
    !isPageHidden('management.incident-management') && (
      <MiniRoute
        //
        key='incident-management'
        path={`/${route}/incident-management`}
        component={IncidentManagementScreen}
        isAuthorized={isAuthorized}
      />
    ),
    !isPageHidden('management.dashboard') && (
      <MiniRoute
        //
        key='dashboard'
        path={`/${route}/dashboard`}
        component={ManagementDashboardScreen}
        isAuthorized={isAuthorized}
      />
    ),
    // TODO: @Bandita fix these routes later
    !isPageHidden('management.report-management') && (
      <MiniRoute
        //
        key='report-management'
        path={`/${route}/report-management`}
        component={ReportManagementScreenV2}
        isAuthorized={isAuthorized}
      />
    ),
    !isPageHidden('management.bulletins') && (
      <MiniRoute
        //
        key='bulletins'
        path={`/${route}/bulletins`}
        component={BulletinManagementScreen}
        isAuthorized={isAuthorized}
      />
    ),
  ];
};
